import {combineReducers, configureStore} from "@reduxjs/toolkit";
import authReducer from "../reducers/auth.reducer";
import characterReducer from "../reducers/character.reducer";

const rootReducer = combineReducers({
    auth : authReducer,
    character: characterReducer,
})

export default configureStore({
    reducer: rootReducer,
})